require(['jquery', 'vue', 'cc-add-cart'], function ($, Vue) {
    $(function () {
        $(".add-cart-btn-wrap").each(function () {
            var product_id = $(this).data('product-id');
            new Vue({
                el        : '#add-cart-' + product_id,
                delimiters: ['@{', '}@'],
            });
        });
    });
});